export const DamsColors = {
    Authentication: {
        AuthContainer: 'rgba(255, 255, 255, 0.75)',
        InputBorder: '#9BA698',
        InputLabel: '#2A3227',
        IconColor: '#63705F',
        CheckBoxLabel: '#11160F',
        Button: '#0A933B',
        labelText: '#2A3227',
        labelTextLight: '#455042',
    },

    SideBar: {
        SideBarContainer: '#F5F5F5',
        SideBarIcon: '#63705F',
        SideBarText: '#2A3227',
        SideBarTextActive: '#0A933B',
    },

    Border: {
        InputOuterBorder: '#9BA698',
        FooterDivider: '#B7C1B6',
        DrawerBorder: '#2A3227',
        PageInput: '#D0D5DD',
    },

    Text: {
        PrimaryText: '#2A3227',
        SecondaryText: '#63705F',
        Highlight: '#0A933B',
        LabelTextLight: '#455042',
        WhiteText: 'white',
        PageLabel: '#344054',
        Black: 'rgba(2, 2, 2, 1)',
        Black2: '#020202'
    },

    Button: {
        Primary: '#0A933B',
        Text: '#F3FFF7',
    },

    Background: {
        Notification: '#F3FFF7',
        RoundCircleActive: '#04BB47',
        RoundCircle: '#B7C1B6',
        TableHeader: '#F5FAF4'
    },

    Badge: {
        Red: {
            border: '#FECACA',
            background: '#FEF2F2',
            text: '#B91C1C',
        },

        Yellow: {
            border: '#FFED79',
            background: '#FFFADC',
            text: '#AE5700',
        },

        Blue: {
            border: '#BFDBFE',
            background: '#EFF6FF',
            text: '#1D4ED8',
        },

        Green: {
            border: '#B6FCCF',
            background: '#F3FFF7',
            text: '#0A933B',
        },

        Grey: {
            border: '#B7C1B6',
            background: '#F5FAF4',
            text: '#2A3227',
        },

        Orange: {
            border: '#FED7AA',
            background: '#FFF7ED',
            text: '#C2410C',
        }
    }
}
